import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'

import StoreBadges from './StoreBadges'
import VenueNewsletter from './VenueNewsletter'

const currentYear = new Date().getFullYear().toString()

const Footer = () => {
  return (
    <Box backgroundColor="midnight">
      <Stack
        gap={8}
        justifyContent="space-around"
        sx={{ p: 4, flexDirection: { xs: 'column-reverse', sm: 'row' }, flexWrap: { xs: 'revert', sm: 'initial' } }}
      >
        <StoreBadges />
        <VenueNewsletter />
      </Stack>
      <Box sx={{ textAlign: 'center', backgroundColor: 'rgba(20, 20, 20, 0.5)', p: 4 }}>
        <Text variant="label" sx={{ color: 'gray' }}>
          <Localized id="footer-copyright-disclaimer" params={{ currentYear }} />
        </Text>
      </Box>
    </Box>
  )
}

export default Footer
